<div class="m-evaluation">
  <app-ui-section-header
    [title]="'EVALUATION.TITLE' | translate"
    [description]="'EVALUATION.SUBTITLE' | translate"
  />

  <div class="m-evaluation__warning">
    <mat-icon class="m-evaluation__warning-icon">warning</mat-icon>
    <span class="m-evaluation__warning-text">{{ 'EVALUATION.WARNING-MESSAGE' | translate }}</span>
  </div>

  <!-- Language Tabs -->
  <div class="m-evaluation__tabs">
    @for (lang of availableLanguages; track lang.code) {
    <button
      class="m-evaluation__tab"
      [class.m-evaluation__tab--active]="currentLanguage() === lang.code"
      (click)="onLanguageChange(lang.code)"
    >
      {{ lang.label }}
    </button>
    }
  </div>

  @if (isLoading()) {
  <div class="m-evaluation__loading">{{ 'COMMON.LOADING' | translate }}</div>
  } @else if (error()) {
  <div class="m-evaluation__error">{{ 'COMMON.ERROR' | translate }}: {{ error() }}</div>
  } @else if (config(); as cfg) {
  <!-- Rating Threshold Card -->
  <div class="m-card m-evaluation__threshold-card">
    <div class="m-evaluation__threshold-container">
      <label class="m-evaluation__threshold-label">{{
        'EVALUATION.THRESHOLD.LABEL' | translate
      }}</label>
      <div class="m-evaluation__threshold-input-wrapper">
        <input
          type="number"
          min="1"
          max="5"
          [value]="threshold()"
          (input)="onThresholdChange(+$any($event.target).value)"
          class="m-evaluation__threshold-input"
        />
        <div class="m-evaluation__stars">
          @for (star of [1, 2, 3, 4, 5]; track star) {
          <span [class.m-evaluation__star--active]="star <= threshold()">★</span>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Two-column Motives Layout -->
  <div class="m-card m-evaluation__motives-grid">
    <!-- Negative Motives -->
    <div class="m-evaluation__column">
      <h4 class="m-evaluation__column-title m-evaluation__column-title--negative">
        <mat-icon class="m-evaluation__icon">thumb_down</mat-icon>
        {{ 'EVALUATION.NEGATIVE_MOTIVES' | translate }}
      </h4>
      <app-motive-editor
        [motives]="negativeMotives()"
        [type]="'negative'"
        (motiveUpdate)="onMotiveUpdate($event)"
        (motiveAdd)="onMotiveAdd($event)"
        (motiveDelete)="onMotiveDelete($event)"
        (subMotiveAdd)="onSubMotiveAdd($event)"
        (subMotiveUpdate)="onSubMotiveUpdate($event)"
        (subMotiveDelete)="onSubMotiveDelete($event)"
      />
    </div>

    <!-- Positive Motives -->
    <div class="m-evaluation__column">
      <h4 class="m-evaluation__column-title m-evaluation__column-title--positive">
        <mat-icon class="m-evaluation__icon">thumb_up</mat-icon>
        {{ 'EVALUATION.POSITIVE_MOTIVES' | translate }}
      </h4>
      <app-motive-editor
        [motives]="positiveMotives()"
        [type]="'positive'"
        (motiveUpdate)="onMotiveUpdate($event)"
        (motiveAdd)="onMotiveAdd($event)"
        (motiveDelete)="onMotiveDelete($event)"
        (subMotiveAdd)="onSubMotiveAdd($event)"
        (subMotiveUpdate)="onSubMotiveUpdate($event)"
        (subMotiveDelete)="onSubMotiveDelete($event)"
      />
    </div>
  </div>

  }
</div>

<app-delete-confirmation-modal
  [isOpen]="showDeleteModal()"
  [title]="'COMMON.DELETE_MODAL.TITLE' | translate"
  [message]="'COMMON.DELETE_MODAL.MESSAGE' | translate"
  [confirmLabel]="'COMMON.DELETE_MODAL.CONFIRM' | translate"
  [cancelLabel]="'COMMON.DELETE_MODAL.CANCEL' | translate"
  [deletingLabel]="'COMMON.DELETE_MODAL.DELETING' | translate"
  [isDeleting]="isLoading()"
  (confirmed)="onConfirmDelete()"
  (cancelled)="onCancelDelete()"
/>
